import { Caption, useStyles, useTheme } from '@archipro-design/aria';
import * as S from './OverlayCaption.style';

interface OverlayCaptionProps {
    firstLine: string;
    secondLine: string;
}

const OverlayCaption = ({ firstLine, secondLine }: OverlayCaptionProps) => {
    const { css } = useStyles();
    const theme = useTheme();

    return (
        <div className={css(S.OverlayCaption)}>
            <Caption
                variant="05"
                variables={{
                    captionColor: theme.siteVariables.colors.white['000'],
                }}
                maximumLines={1}
            >
                {firstLine}
            </Caption>
            <Caption
                variant="05"
                variables={{
                    captionColor: theme.siteVariables.colors.white['000'],
                }}
                maximumLines={1}
            >
                {secondLine}
            </Caption>
        </div>
    );
};

export default OverlayCaption;
